export default {
  'case1': {
    index: 'CASE 1',
    case: 'CASE 1',
    title: 'ロサンゼルス・コネクション',
    release: '2020.12.16 Wed. RELEASE',
    images: [
      '/assets/images/bd-case1-2.jpg',
      '/assets/images/bd-case1-3.jpg'
    ],
    notice:
      '※商品仕様・特典内容は予告無く変更になる場合がございます。あらかじめご了承ください。',
    spec: {
      '品番': 'TBR31041D',
      'POS': '4988104127419',
      '価格': '¥12,000＋税',
      '形態': 'Blu-ray<br>本編約120分（収録話数：第1話～第5話）',
      '仕様': 'ディスク1枚組/カラー/1080p High Definition/16:9ワイドスクリーン/日本語 リニアPCM 2.0ch ステレオ/2層（BD50G）',
      '【特典内容】': '　',
      '仕様 ':
        '◆着せ替えジャケットカード（イラスト：加藤寛崇）<br>' +
        '<figure><img src="/assets/images/bd-case1.jpg" alt=""></figure>' +
        '◆サブキャラクターデザイン・総作画監督 加藤寛崇 描き下ろしデジパック',
      '封入特典': '◆アートブック（約40P）',
      '映像特典':
        '◆デフォルメキャラクターによるネタバレだらけの暴露大会フラッシュアニメ（約26分）<br>' +
        '◆TVアニメ「GREAT PRETENDER（グレートプリテンダー）」主題歌スペシャルPV 【FreddieMercury（フレディ・マーキュリー）】<br>' +
        '◆ノンクレジットオープニング<br>' +
        '◆ノンクレジットエンディング',
      '音声特典':
        '◆ALL日本キャストパターン音声（１話）<br>' +
        '◆TVオンエア版オーディオコメンタリー（1～2話）',
      '封入施策':
        '◆Blu-rayランダム封入施策<br>「キャスト生サイン入り特製トランプ」追加決定！<br>' +
        '<a href="/news/029">https://www.greatpretender.jp/news/029</a>'
    },
    shop: {
      'Amazon':
        'CASE 1〜3 連動購入特典：CASE 1～3収納BOX<br>' +
        '<figure><img src="/assets/images/bd-amazon1.jpg" alt=""></figure>' +
        'CASE 4【前篇】【後篇】連動購入特典：<br>CASE 4【前篇】【後篇】収納BOX<br>' +
        '<figure><img src="/assets/images/bd-amazon2.jpg" alt=""></figure>' +
        '<a class="has-text-weight-bold" target="_blank" rel="noopener" href="https://www.amazon.co.jp/s?hidden-keywords=B08DTZDDVG%7CB08DTXY92R%7CB08DTY7G5Y">詳しくはこちら</a>',
      'TOHO animation STORE':
        'CASE 1〜3 連動購入特典：<br>' +
        '①オリジナルデザインTシャツ<br>' +
        '<figure><img src="/assets/images/bd-toho.jpg" alt=""></figure>' +
        '②ビジュアルポストカード４枚セット<br>' +
        '<figure><img src="/assets/images/bd-toho2.jpg" alt=""></figure>' +
        'CASE 4【前篇】【後篇】連動購入特典：<br>複製原画シート4枚セット<br>' +
        '<figure><img src="/assets/images/bd-toho3.jpg" alt=""></figure>' +
        '<a class="has-text-weight-bold" target="_blank" rel="noopener" href="https://tohoanimationstore.com/shop/c/c67/">詳しくはこちら</a>',
      'アニメイト':
        'CASE 1〜3 連動購入特典：<br>' +
        '①アクリルスタンド2個セット<br>' +
        '<figure><img src="/assets/images/bd-animate1.jpg" alt=""></figure>' +
        '②B2モニターカバークロス<br>' +
        '<figure><img src="/assets/images/bd-animate2.jpg" alt=""></figure>' +
        'CASE 4【前篇】【後篇】連動購入特典：<br>キャンバスサコッシュ<br>' +
        '<a class="has-text-weight-bold" target="_blank" rel="noopener" href="https://www.animate-onlineshop.jp/products/bulk_purchase_detail.php?id=3357">詳しくはこちら</a>',
      '楽天ブックス':
        'CASE 1〜3 連動購入特典：<br>' +
        '①オリジナルA3ポスター<br>' +
        '<figure><img src="/assets/images/bd-rakuten2.jpg" alt=""></figure>' +
        '②場面写ポストカード5枚セット<br>' +
        '<figure><img src="/assets/images/bd-rakuten1.jpg" alt=""></figure>' +
        'CASE 4【前篇】【後篇】連動購入特典：<br>①オリジナルA3ポスター<br>②場面写ポストカード5枚セット<br>' +
        '<a class="has-text-weight-bold" target="_blank" rel="noopener" href="https://r10.to/hlXxaS">詳しくはこちら</a>',
      'Loppi・HMV':
        'CASE 1〜3 連動購入特典：<br>アクリルコースター2個セット（枝村＆ローラン）<br>' +
        '<figure><img src="/assets/images/bd-hmv1.jpg" alt=""></figure>' +
        'CASE 4【前篇】【後篇】連動購入特典：<br>アクリルコースター2個セット（アビー＆シンシア）<br>' +
        '<figure><img src="/assets/images/bd-hmv2.jpg" alt=""></figure>' +
        '<a class="has-text-weight-bold" target="_blank" rel="noopener" href="https://www.hmv.co.jp/news/article/2008041015/">詳しくはこちら</a>',
      'WITアプリ':
        '全巻購入特典：額装付き 複製原画<br>' +
        '※全4種の中から1種選択が可能です<br>' +
        '①エダマメ<br>' +
        '<figure><img src="/assets/images/bd-wit1.jpg" alt=""></figure>' +
        '②ローラン<br>' +
        '<figure><img src="/assets/images/bd-wit2.jpg" alt=""></figure>' +
        '③アビー<br>' +
        '<figure><img src="/assets/images/bd-wit3.jpg" alt=""></figure>' +
        '④シンシア<br>' +
        '<figure><img src="/assets/images/bd-wit4.jpg" alt=""></figure>' +
        '<a class="has-text-weight-bold" target="_blank" rel="noopener" href="http://www.witstudio.co.jp/news/2020/09/529.html">詳しくはこちら</a>'
    }
  },
  'case2': {
    index: 'CASE 2',
    case: 'CASE 2',
    title: 'シンガポール・スカイ',
    release: '2021.1.20 Wed. RELEASE',
    images: [
      '/assets/images/bd-case2-2.jpg',
      '/assets/images/bd-case2-3.jpg'
    ],
    notice:
      '※商品仕様・特典内容は予告無く変更になる場合がございます。あらかじめご了承ください。',
    spec: {
      '品番': 'TBR31042D',
      'POS': '4988104127426',
      '価格': '¥12,000＋税',
      '形態': 'Blu-ray<br>本編約120分（収録話数：第6話～第10話）',
      '仕様': 'ディスク1枚組/カラー/1080p High Definition/16:9ワイドスクリーン/日本語 リニアPCM 2.0ch ステレオ/2層（BD50G）',
      '【特典内容】': '　',
      '仕様 ':
        '◆着せ替えジャケットカード（イラスト：石橋翔祐）' +
        '<figure><img src="/assets/images/bd-case2-4.jpg" alt=""></figure>' +
        '◆サブキャラクターデザイン・総作画監督 加藤寛崇 描き下ろしデジパック',
      '封入特典': '◆アートブック（約40P）',
      '映像特典': '◆ティザーPV<br>◆メインPV第1弾<br>◆メインPV第2弾<br>◆メインPV第3弾'
    },
    shop: {
      'Amazon':
        'CASE 1〜3 連動購入特典：CASE 1～3収納BOX<br>' +
        '<figure><img src="/assets/images/bd-amazon1.jpg" alt=""></figure>' +
        'CASE 4【前篇】【後篇】連動購入特典：<br>CASE 4【前篇】【後篇】収納BOX<br>' +
        '<figure><img src="/assets/images/bd-amazon2.jpg" alt=""></figure>' +
        '<a class="has-text-weight-bold" target="_blank" rel="noopener" href="https://www.amazon.co.jp/s?hidden-keywords=B08DTZDDVG%7CB08DTXY92R%7CB08DTY7G5Y">詳しくはこちら</a>',
      'TOHO animation STORE':
        'CASE 1〜3 連動購入特典：<br>' +
        '①オリジナルデザインTシャツ<br>' +
        '<figure><img src="/assets/images/bd-toho.jpg" alt=""></figure>' +
        '②ビジュアルポストカード４枚セット<br>' +
        '<figure><img src="/assets/images/bd-toho2.jpg" alt=""></figure>' +
        'CASE 4【前篇】【後篇】連動購入特典：<br>複製原画シート4枚セット<br>' +
        '<figure><img src="/assets/images/bd-toho3.jpg" alt=""></figure>' +
        '<a class="has-text-weight-bold" target="_blank" rel="noopener" href="https://tohoanimationstore.com/shop/c/c67/">詳しくはこちら</a>',
      'アニメイト':
        'CASE 1〜3 連動購入特典：<br>' +
        '①アクリルスタンド2個セット<br>' +
        '<figure><img src="/assets/images/bd-animate1.jpg" alt=""></figure>' +
        '②B2モニターカバークロス<br>' +
        '<figure><img src="/assets/images/bd-animate2.jpg" alt=""></figure>' +
        'CASE 4【前篇】【後篇】連動購入特典：<br>キャンバスサコッシュ<br>' +
        '<a class="has-text-weight-bold" target="_blank" rel="noopener" href="https://www.animate-onlineshop.jp/products/bulk_purchase_detail.php?id=3357">詳しくはこちら</a>',
      '楽天ブックス':
        'CASE 1〜3 連動購入特典：<br>' +
        '①オリジナルA3ポスター<br>' +
        '<figure><img src="/assets/images/bd-rakuten2.jpg" alt=""></figure>' +
        '②場面写ポストカード5枚セット<br>' +
        '<figure><img src="/assets/images/bd-rakuten1.jpg" alt=""></figure>' +
        'CASE 4【前篇】【後篇】連動購入特典：<br>①オリジナルA3ポスター<br>②場面写ポストカード5枚セット<br>' +
        '<a class="has-text-weight-bold" target="_blank" rel="noopener" href="https://r10.to/hlXxaS">詳しくはこちら</a>',
      'Loppi・HMV':
        'CASE 1〜3 連動購入特典：<br>アクリルコースター2個セット（枝村＆ローラン）<br>' +
        '<figure><img src="/assets/images/bd-hmv1.jpg" alt=""></figure>' +
        'CASE 4【前篇】【後篇】連動購入特典：<br>アクリルコースター2個セット（アビー＆シンシア）<br>' +
        '<figure><img src="/assets/images/bd-hmv2.jpg" alt=""></figure>' +
        '<a class="has-text-weight-bold" target="_blank" rel="noopener" href="https://www.hmv.co.jp/news/article/2008041015/">詳しくはこちら</a>',
      'WITアプリ':
        '全巻購入特典：額装付き 複製原画<br>' +
        '※全4種の中から1種選択が可能です<br>' +
        '①エダマメ<br>' +
        '<figure><img src="/assets/images/bd-wit1.jpg" alt=""></figure>' +
        '②ローラン<br>' +
        '<figure><img src="/assets/images/bd-wit2.jpg" alt=""></figure>' +
        '③アビー<br>' +
        '<figure><img src="/assets/images/bd-wit3.jpg" alt=""></figure>' +
        '④シンシア<br>' +
        '<figure><img src="/assets/images/bd-wit4.jpg" alt=""></figure>' +
        '<a class="has-text-weight-bold" target="_blank" rel="noopener" href="http://www.witstudio.co.jp/news/2020/09/529.html">詳しくはこちら</a>'
    }
  },
  'case3': {
    index: 'CASE 3',
    case: 'CASE 3',
    title: 'スノー・オブ・ロンドン',
    release: '2021.2.17 Wed. RELEASE',
    images: [
      '/assets/images/bd-case3-2.jpg',
      '/assets/images/bd-case3-3.jpg'
    ],
    notice:
      '※商品仕様・特典内容は予告無く変更になる場合がございます。あらかじめご了承ください。',
    spec: {
      '品番': 'TBR31043D',
      'POS': '4988104127433',
      '価格': '¥12,000＋税',
      '形態': 'Blu-ray<br>本編約120分（収録話数：第11話～第14話）',
      '仕様': 'ディスク1枚組/カラー/1080p High Definition/16:9ワイドスクリーン/日本語 リニアPCM 2.0ch ステレオ/2層（BD50G）',
      '【特典内容】': '　',
      '仕様 ':
        '◆着せ替えジャケットカード(イラスト：藤井一志）<br>' +
        '<figure><img src="/assets/images/bd-case3-4.jpg" alt=""></figure>' +
        '◆サブキャラクターデザイン・総作画監督 加藤寛崇 描き下ろしデジパック',
      '封入特典': '◆アートブック（約40P）',
      '音声特典': '◆ALL日本キャストパターン音声（11話、14話）',
      '映像特典':
        '◆プロジェクトPV<br>' +
        '◆メインPV第4弾<br>' +
        '◆メインPV第5弾<br>' +
        '◆スペシャルMV'
    },
    shop: {
      'Amazon':
        'CASE 1〜3 連動購入特典：CASE 1～3収納BOX<br>' +
        '<figure><img src="/assets/images/bd-amazon1.jpg" alt=""></figure>' +
        'CASE 4【前篇】【後篇】連動購入特典：<br>CASE 4【前篇】【後篇】収納BOX<br>' +
        '<figure><img src="/assets/images/bd-amazon2.jpg" alt=""></figure>' +
        '<a class="has-text-weight-bold" target="_blank" rel="noopener" href="https://www.amazon.co.jp/s?hidden-keywords=B08DTZDDVG%7CB08DTXY92R%7CB08DTY7G5Y">詳しくはこちら</a>',
      'TOHO animation STORE':
        'CASE 1〜3 連動購入特典：<br>' +
        '①オリジナルデザインTシャツ<br>' +
        '<figure><img src="/assets/images/bd-toho.jpg" alt=""></figure>' +
        '②ビジュアルポストカード４枚セット<br>' +
        '<figure><img src="/assets/images/bd-toho2.jpg" alt=""></figure>' +
        'CASE 4【前篇】【後篇】連動購入特典：<br>複製原画シート4枚セット<br>' +
        '<figure><img src="/assets/images/bd-toho3.jpg" alt=""></figure>' +
        '<a class="has-text-weight-bold" target="_blank" rel="noopener" href="https://tohoanimationstore.com/shop/c/c67/">詳しくはこちら</a>',
      'アニメイト':
        'CASE 1〜3 連動購入特典：<br>' +
        '①アクリルスタンド2個セット<br>' +
        '<figure><img src="/assets/images/bd-animate1.jpg" alt=""></figure>' +
        '②B2モニターカバークロス<br>' +
        '<figure><img src="/assets/images/bd-animate2.jpg" alt=""></figure>' +
        'CASE 4【前篇】【後篇】連動購入特典：<br>キャンバスサコッシュ<br>' +
        '<a class="has-text-weight-bold" target="_blank" rel="noopener" href="https://www.animate-onlineshop.jp/products/bulk_purchase_detail.php?id=3357">詳しくはこちら</a>',
      '楽天ブックス':
        'CASE 1〜3 連動購入特典：<br>' +
        '①オリジナルA3ポスター<br>' +
        '<figure><img src="/assets/images/bd-rakuten2.jpg" alt=""></figure>' +
        '②場面写ポストカード5枚セット<br>' +
        '<figure><img src="/assets/images/bd-rakuten1.jpg" alt=""></figure>' +
        'CASE 4【前篇】【後篇】連動購入特典：<br>①オリジナルA3ポスター<br>②場面写ポストカード5枚セット<br>' +
        '<a class="has-text-weight-bold" target="_blank" rel="noopener" href="https://r10.to/hlXxaS">詳しくはこちら</a>',
      'Loppi・HMV':
        'CASE 1〜3 連動購入特典：<br>アクリルコースター2個セット（枝村＆ローラン）<br>' +
        '<figure><img src="/assets/images/bd-hmv1.jpg" alt=""></figure>' +
        'CASE 4【前篇】【後篇】連動購入特典：<br>アクリルコースター2個セット（アビー＆シンシア）<br>' +
        '<figure><img src="/assets/images/bd-hmv2.jpg" alt=""></figure>' +
        '<a class="has-text-weight-bold" target="_blank" rel="noopener" href="https://www.hmv.co.jp/news/article/2008041015/">詳しくはこちら</a>',
      'WITアプリ':
        '全巻購入特典：額装付き 複製原画<br>' +
        '※全4種の中から1種選択が可能です<br>' +
        '①エダマメ<br>' +
        '<figure><img src="/assets/images/bd-wit1.jpg" alt=""></figure>' +
        '②ローラン<br>' +
        '<figure><img src="/assets/images/bd-wit2.jpg" alt=""></figure>' +
        '③アビー<br>' +
        '<figure><img src="/assets/images/bd-wit3.jpg" alt=""></figure>' +
        '④シンシア<br>' +
        '<figure><img src="/assets/images/bd-wit4.jpg" alt=""></figure>' +
        '<a class="has-text-weight-bold" target="_blank" rel="noopener" href="http://www.witstudio.co.jp/news/2020/09/529.html">詳しくはこちら</a>'
    }
  },
  'case4_1': {
    index: 'CASE 4【前篇】',
    case: 'CASE 4',
    title: 'ウィザード・オブ・ファー・イースト【前篇】',
    release: '2021.3.17 Wed. RELEASE',
    images: [
      '/assets/images/bd-case4-2.jpg',
      '/assets/images/bd-case4-3.jpg'
    ],
    notice:
      '※商品仕様・特典内容は予告無く変更になる場合がございます。あらかじめご了承ください。',
    spec: {
      '品番': 'TBR31044D',
      'POS': '4988104127440',
      '価格': '¥12,000＋税',
      '形態': 'Blu-ray<br>本編約120分（収録話数：第15話～第19話）',
      '仕様': 'ディスク1枚組/カラー/1080p High Definition/16:9ワイドスクリーン/日本語 リニアPCM 2.0ch ステレオ/2層（BD50G）',
      '【特典内容】': '　',
      '仕様 ':
        '◆着せ替えジャケットカード(イラスト：貞本義行）<br>' +
        '<figure><img src="/assets/images/bd-case4-4.jpg" alt=""></figure>' +
        '◆サブキャラクターデザイン・総作画監督 加藤寛崇 描き下ろしデジパック',
      '封入特典': '◆アートブック（約40P）',
      '音声特典': '◆ALL日本キャストパターン音声（16話～19話）'
    },
    shop: {
      'Amazon':
        'CASE 1〜3 連動購入特典：CASE 1～3収納BOX<br>' +
        '<figure><img src="/assets/images/bd-amazon1.jpg" alt=""></figure>' +
        'CASE 4【前篇】【後篇】連動購入特典：<br>CASE 4【前篇】【後篇】収納BOX<br>' +
        '<figure><img src="/assets/images/bd-amazon2.jpg" alt=""></figure>' +
        '<a class="has-text-weight-bold" target="_blank" rel="noopener" href="https://www.amazon.co.jp/s?hidden-keywords=B08DTZDDVG%7CB08DTXY92R%7CB08DTY7G5Y">詳しくはこちら</a>',
      'TOHO animation STORE':
        'CASE 1〜3 連動購入特典：<br>' +
        '①オリジナルデザインTシャツ<br>' +
        '<figure><img src="/assets/images/bd-toho.jpg" alt=""></figure>' +
        '②ビジュアルポストカード４枚セット<br>' +
        '<figure><img src="/assets/images/bd-toho2.jpg" alt=""></figure>' +
        'CASE 4【前篇】【後篇】連動購入特典：<br>複製原画シート4枚セット<br>' +
        '<figure><img src="/assets/images/bd-toho3.jpg" alt=""></figure>' +
        '<a class="has-text-weight-bold" target="_blank" rel="noopener" href="https://tohoanimationstore.com/shop/c/c67/">詳しくはこちら</a>',
      'アニメイト':
        'CASE 1〜3 連動購入特典：<br>' +
        '①アクリルスタンド2個セット<br>' +
        '<figure><img src="/assets/images/bd-animate1.jpg" alt=""></figure>' +
        '②B2モニターカバークロス<br>' +
        '<figure><img src="/assets/images/bd-animate2.jpg" alt=""></figure>' +
        'CASE 4【前篇】【後篇】連動購入特典：<br>キャンバスサコッシュ<br>' +
        '<a class="has-text-weight-bold" target="_blank" rel="noopener" href="https://www.animate-onlineshop.jp/products/bulk_purchase_detail.php?id=3357">詳しくはこちら</a>',
      '楽天ブックス':
        'CASE 1〜3 連動購入特典：<br>' +
        '①オリジナルA3ポスター<br>' +
        '<figure><img src="/assets/images/bd-rakuten2.jpg" alt=""></figure>' +
        '②場面写ポストカード5枚セット<br>' +
        '<figure><img src="/assets/images/bd-rakuten1.jpg" alt=""></figure>' +
        'CASE 4【前篇】【後篇】連動購入特典：<br>①オリジナルA3ポスター<br>②場面写ポストカード5枚セット<br>' +
        '<a class="has-text-weight-bold" target="_blank" rel="noopener" href="https://r10.to/hlXxaS">詳しくはこちら</a>',
      'Loppi・HMV':
        'CASE 1〜3 連動購入特典：<br>アクリルコースター2個セット（枝村＆ローラン）<br>' +
        '<figure><img src="/assets/images/bd-hmv1.jpg" alt=""></figure>' +
        'CASE 4【前篇】【後篇】連動購入特典：<br>アクリルコースター2個セット（アビー＆シンシア）<br>' +
        '<figure><img src="/assets/images/bd-hmv2.jpg" alt=""></figure>' +
        '<a class="has-text-weight-bold" target="_blank" rel="noopener" href="https://www.hmv.co.jp/news/article/2008041015/">詳しくはこちら</a>',
      'WITアプリ':
        '全巻購入特典：額装付き 複製原画<br>' +
        '※全4種の中から1種選択が可能です<br>' +
        '①エダマメ<br>' +
        '<figure><img src="/assets/images/bd-wit1.jpg" alt=""></figure>' +
        '②ローラン<br>' +
        '<figure><img src="/assets/images/bd-wit2.jpg" alt=""></figure>' +
        '③アビー<br>' +
        '<figure><img src="/assets/images/bd-wit3.jpg" alt=""></figure>' +
        '④シンシア<br>' +
        '<figure><img src="/assets/images/bd-wit4.jpg" alt=""></figure>' +
        '<a class="has-text-weight-bold" target="_blank" rel="noopener" href="http://www.witstudio.co.jp/news/2020/09/529.html">詳しくはこちら</a>'
    }
  },
  'case4_2': {
    index: 'CASE 4【後篇】',
    case: 'CASE 4',
    title: 'ウィザード・オブ・ファー・イースト【後篇】',
    release: '2021.4.21 Wed. RELEASE',
    images: [
      '/assets/images/bd-case42-2.jpg',
      '/assets/images/bd-case42-3.jpg'
    ],
    notice:
      '※商品仕様・特典内容は予告無く変更になる場合がございます。あらかじめご了承ください。',
    spec: {
      '品番': 'TBR31045D',
      'POS': '4988104127457',
      '価格': '¥12,000＋税',
      '形態': 'Blu-ray<br>本編約120分（収録話数：第20話～第23話）',
      '仕様': 'ディスク1枚組/カラー/1080p High Definition/16:9ワイドスクリーン/日本語 リニアPCM 2.0ch ステレオ/2層（BD50G）',
      '【特典内容】': '　',
      '仕様 ': '◆着せ替えジャケットカード（イラスト：加藤寛崇）<br>' +
      '<figure><img src="/assets/images/bd-case42-4.jpg" alt=""></figure>' +
      '◆サブキャラクターデザイン・総作画監督 加藤寛崇 描き下ろしデジパック',
      '封入特典': '◆アートブック（約40P）',
      '音声特典': '◆ALL日本キャストパターン音声（20話～23話）'
    },
    shop: {
      'Amazon':
        'CASE 1〜3 連動購入特典：CASE 1～3収納BOX<br>' +
        '<figure><img src="/assets/images/bd-amazon1.jpg" alt=""></figure>' +
        'CASE 4【前篇】【後篇】連動購入特典：<br>CASE 4【前篇】【後篇】収納BOX<br>' +
        '<figure><img src="/assets/images/bd-amazon2.jpg" alt=""></figure>' +
        '<a class="has-text-weight-bold" target="_blank" rel="noopener" href="https://www.amazon.co.jp/s?hidden-keywords=B08DTZDDVG%7CB08DTXY92R%7CB08DTY7G5Y">詳しくはこちら</a>',
      'TOHO animation STORE':
        'CASE 1〜3 連動購入特典：<br>' +
        '①オリジナルデザインTシャツ<br>' +
        '<figure><img src="/assets/images/bd-toho.jpg" alt=""></figure>' +
        '②ビジュアルポストカード４枚セット<br>' +
        '<figure><img src="/assets/images/bd-toho2.jpg" alt=""></figure>' +
        'CASE 4【前篇】【後篇】連動購入特典：<br>複製原画シート4枚セット<br>' +
        '<figure><img src="/assets/images/bd-toho3.jpg" alt=""></figure>' +
        '<a class="has-text-weight-bold" target="_blank" rel="noopener" href="https://tohoanimationstore.com/shop/c/c67/">詳しくはこちら</a>',
      'アニメイト':
        'CASE 1〜3 連動購入特典：<br>' +
        '①アクリルスタンド2個セット<br>' +
        '<figure><img src="/assets/images/bd-animate1.jpg" alt=""></figure>' +
        '②B2モニターカバークロス<br>' +
        '<figure><img src="/assets/images/bd-animate2.jpg" alt=""></figure>' +
        'CASE 4【前篇】【後篇】連動購入特典：<br>キャンバスサコッシュ<br>' +
        '<a class="has-text-weight-bold" target="_blank" rel="noopener" href="https://www.animate-onlineshop.jp/products/bulk_purchase_detail.php?id=3357">詳しくはこちら</a>',
      '楽天ブックス':
        'CASE 1〜3 連動購入特典：<br>' +
        '①オリジナルA3ポスター<br>' +
        '<figure><img src="/assets/images/bd-rakuten2.jpg" alt=""></figure>' +
        '②場面写ポストカード5枚セット<br>' +
        '<figure><img src="/assets/images/bd-rakuten1.jpg" alt=""></figure>' +
        'CASE 4【前篇】【後篇】連動購入特典：<br>①オリジナルA3ポスター<br>②場面写ポストカード5枚セット<br>' +
        '<a class="has-text-weight-bold" target="_blank" rel="noopener" href="https://r10.to/hlXxaS">詳しくはこちら</a>',
      'Loppi・HMV':
        'CASE 1〜3 連動購入特典：<br>アクリルコースター2個セット（枝村＆ローラン）<br>' +
        '<figure><img src="/assets/images/bd-hmv1.jpg" alt=""></figure>' +
        'CASE 4【前篇】【後篇】連動購入特典：<br>アクリルコースター2個セット（アビー＆シンシア）<br>' +
        '<figure><img src="/assets/images/bd-hmv2.jpg" alt=""></figure>' +
        '<a class="has-text-weight-bold" target="_blank" rel="noopener" href="https://www.hmv.co.jp/news/article/2008041015/">詳しくはこちら</a>',
      'WITアプリ':
        '全巻購入特典：額装付き 複製原画<br>' +
        '※全4種の中から1種選択が可能です<br>' +
        '①エダマメ<br>' +
        '<figure><img src="/assets/images/bd-wit1.jpg" alt=""></figure>' +
        '②ローラン<br>' +
        '<figure><img src="/assets/images/bd-wit2.jpg" alt=""></figure>' +
        '③アビー<br>' +
        '<figure><img src="/assets/images/bd-wit3.jpg" alt=""></figure>' +
        '④シンシア<br>' +
        '<figure><img src="/assets/images/bd-wit4.jpg" alt=""></figure>' +
        '<a class="has-text-weight-bold" target="_blank" rel="noopener" href="http://www.witstudio.co.jp/news/2020/09/529.html">詳しくはこちら</a>'
    }
  }
}



// WEBPACK FOOTER //
// ./src/data/bd.js